import { Box, Button, VStack } from '@chakra-ui/react'
import { Add } from '@material-ui/icons'
import type { Moment } from 'moment'
import React from 'react'
import { MiniCalendar } from './mini-calendar'
import { MyCalendars } from './my-calendars'

interface CalendarSidebarProps {
  navigationDate: Moment
  onMiniCalendarDateClick: (date: Moment) => void
  onAddNewEventClick: () => void
  enabledCalendars: Record<string, boolean>
  setEnabledCalendars: (calendars: Record<string, boolean>) => void
}

export const CalendarSidebar: React.FC<CalendarSidebarProps> = ({
  navigationDate,
  onMiniCalendarDateClick,
  onAddNewEventClick,
  enabledCalendars,
  setEnabledCalendars
}) => {
  return (
    <Box
      w="259px"
      p="30px 24px 12px 24px"
      borderRight="1px solid rgba(55, 60, 65, 0.14)"
      background="#F9F9F9"
      overflowY="auto"
    >
      <VStack align="start" gap="24px">
        <MiniCalendar
          onDateClick={onMiniCalendarDateClick}
          selectedDate={navigationDate}
        />
        <Button
          size="lg"
          variant="secondary"
          borderRadius="8px"
          border="1px solid rgba(55, 60, 65, 0.14)"
          isFullWidth
          leftIcon={<Add style={{ width: 16, height: 16 }} />}
          fontSize="16px"
          height="48px"
          onClick={onAddNewEventClick}
          _hover={{ bg: 'rgba(45,84,232,0.04)' }}
        >
          Create event
        </Button>
        <MyCalendars
          enabledCalendars={enabledCalendars}
          setEnabledCalendars={setEnabledCalendars}
        />
      </VStack>
    </Box>
  )
}
